// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 MindTenet LLC
// This file is part of Undef Engine.

import type { Card } from './types';

interface QuestionCardProps {
  card: Card;
  selected?: boolean;
  className?: string;
}

export function QuestionCard({ card, selected = false, className = '' }: QuestionCardProps) {
  return (
    <div
      className={`
        border-2 rounded-lg p-6 text-center transition-all
        ${selected ? 'border-amber-500 bg-amber-100 shadow-lg' : 'border-amber-400 bg-amber-400/15'}
        ${className}
      `}
    >
      <div className="mb-2">
        <span className="inline-block px-3 py-1 bg-amber-200 text-amber-800 text-xs font-semibold rounded-full uppercase">
          Question
        </span>
      </div>
      <p className="text-xl font-semibold text-gray-800">{card.text}</p>
      {card.image_url && (
        <img
          src={card.image_url}
          alt="Question illustration"
          className="mt-4 mx-auto max-w-full rounded-lg"
        />
      )}
    </div>
  );
}

export type { QuestionCardProps };
